import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=bc928224&scoped=true&lang=pug&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=bc928224&scoped=true&lang=scss&"
import style1 from "./Layout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc928224",
  null
  
)

export default component.exports